<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12 col-xl-12 bgMainSection bgBlue text-left">
            <form [formGroup]="marketMap">
                <div class="container mainContainer">
                    <div class="row">
                        <div class="col-5 text-left mt-4">
                            <label class="mainHeading">Live Market Map</label>
                        </div>
                        <div class="col-7 text-right mt-4" [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
                            <label class="mainHeading">{{marketName}}</label>
                        </div>
                        <div class="col-12 col-lg-2 text-left text-lg-right mt-4" *ngIf="SwapORamaCustomChanges">
                            <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
                        </div>
                    </div>
                    <div class="bgWghite shadow pt-2 mt-2">
                        <div class="container" style="max-width: 100% !important;">
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-3 col-lg-2 col-xl-2 text-left">
                                            <label class="mt-3 mb-0">Market Day</label>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2 text-left mt-2">
                                            <select class="form-control alignLayoutPart" formControlName="marketDay"
                                                (change)="changeMarketMap()">
                                                <option *ngFor="let item of dailyMarketDays" [value]="item.MarketDays">
                                                    {{item.MarketDays}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-3 col-lg-2 col-xl-2 text-left">
                                            <label class="mt-3 mb-0" for="marketParts">Select Layout Part</label>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2 text-left mt-2">
                                            <select class="form-control alignLayoutPart" formControlName="marketParts"
                                                id="marketParts" (change)="changeMarketMap()">
                                                <option *ngFor="let item of parts" [value]="item.PartId">
                                                    {{item.PartDescription}}</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-3 col-lg-2 col-xl-2 text-left mt-2"
                                            style="display: none;">
                                            <button class="btn btn-primary alignLayoutPart" (click)="viewLayout()">View
                                                Layout</button>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2 d-flex layout_buttons mt-1">
                                            <button class="btn btnZoom alignLayoutPart mr-1"
                                                (click)="layoutZoomInClick($event)">
                                                <img src="../assets/images/ZoomIn.svg" class="img-fluid" />
                                            </button>
                                            <button class="btn btnZoom" (click)="layoutZoomOutClick($event)">
                                                <img src="../assets/images/ZoomOut.svg" class="img-fluid" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left pl-lg-0 mt-2">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="Layout">
                                                <ejs-diagram #diagram id="diagram" width="100%"
                                                    style="overflow: visible; min-height: calc(97vh - 205px);"
                                                    (created)='created($event)' [selectedItems]="selectedItems"
                                                    [snapSettings]='snapSettings'></ejs-diagram>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 text-left"></div>
                                        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 text-left">
                                            <div class="row">
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 text-left">
                                                    <input type="checkbox" class="CheckboxClass chkAvailable mt-2"
                                                        id="chkAvailable" disabled>
                                                    <label for="chkAvailable" class="chkAlign"
                                                        style="margin-left: 4px;">Available</label>
                                                </div>
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 text-left">
                                                    <input type="checkbox" class="CheckboxClass chkBooked mt-2"
                                                        id="chkBooked" disabled>
                                                    <label class="chkAlign" for="chkBooked"
                                                        style="margin-left: 4px;">Booked</label>
                                                </div>
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 text-left">
                                                    <input type="checkbox" class="CheckboxClass chkReserved mt-2"
                                                        id="chkReserved" disabled>
                                                    <label i18n class="chkAlign" for="chkReserved"
                                                        style="margin-left: 4px;">Reserved</label>
                                                </div>
                                                <div class="col-sm-6 col-md-6 col-lg-3 col-xl-3 text-left">
                                                    <input type="checkbox" class="CheckboxClass chkNonRentable mt-2"
                                                        id="chkNonRentable" disabled>
                                                    <label i18n class="chkAlign" for="chkNonRentable"
                                                        style="margin-left: 4px;">Non Rentable</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>